import { useState, useEffect } from "react";
import "./styles/BI.css";
import Search from "../generales/Search";
import Modal from "react-modal";
import { useFetch } from '../../hooks/useFetch';
// import Action from "../Action";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import TableEvents from "./Events/TableEvents";
// import InfoPortafolio from "./Criticidad/InfoPortafolio";
import Paginador from "../generales/Paginador";
// import ModalCreateTech from "./Events/ModalCreateTech";
// import ImportInfo from "./Proxies/ImportInfo";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'; 
import isAfter from 'date-fns/isAfter';
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
import SelectorAdmin from "../SelectorAdmin";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};
const PanelBI = ({ server,languaje,mode,handleShowPopup }) => {
  // const limitList = 200;
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected,setgroupSelected]=useState([])
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading,setExportLoading]=useState(false)
  const dataModulos=useFetch('cassia/audit/modules','','','GET',server)
  const obtenerPrimerDiaDelMes = () => {
    const hoy = new Date();
    const primerDiaDelMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    
    const anio = primerDiaDelMes.getFullYear();
    const mes = String(primerDiaDelMes.getMonth() + 1).padStart(2, '0');
    const dia = String(primerDiaDelMes.getDate()).padStart(2, '0');
    const horas = String(primerDiaDelMes.getHours()).padStart(2, '0');
    const minutos = String(primerDiaDelMes.getMinutes()).padStart(2, '0');
  
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const [opciones,setOpciones]=useState({fecha_ini:''+obtenerPrimerDiaDelMes(),fecha_fin:''+obtenerFechaActualLocal()})
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  const predefinedRanges = [
    {
      label: 'Última hora',
      value: [subHours(new Date(), 1), new Date()],
      placement: 'left'
    },
    {
      label: 'Últimas 3 horas',
      value: [subHours(new Date(), 3), new Date()],
      placement: 'left'
    },
    {
      label: 'Últimas 6 horas',
      value: [subHours(new Date(), 6), new Date()],
      placement: 'left'
    },
    {
      label: 'Últimas 12 horas',
      value: [subHours(new Date(), 12), new Date()],
      placement: 'left'
    },
    {
      label: 'Últimas 24 horas',
      value: [subHours(new Date(), 24), new Date()],
      placement: 'left'
    },
    {
      label: 'Últimas 48 horas',
      value: [subHours(new Date(), 48), new Date()],
      placement: 'left'
    },
    {
      label: 'Esta semana',
      value: [startOfWeek(new Date()), new Date()],
      placement: 'left'
    },
    {
      label: 'Semana pasada',
      value: [subDays(new Date(), 6), new Date()],
      placement: 'left'
    },
    
    {
      label: 'Este mes',
      value: [startOfMonth(new Date()), new Date()],
      placement: 'left'
    },
    {
      label: 'Mes pasado',
      value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'left'
    },
    {
      label: 'Este año',
      value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
      placement: 'left'
    },
    {
      label: 'Año pasado',
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
      placement: 'left'
    },
    
    
  ];
  const formatDate=(date)=>{
    const anio = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
      const dia = String(date.getDate()).padStart(2, '0');
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
    // console.log(`${anio}-${mes}-${dia}T${horas}:${minutos}`)
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }
  const [range, setRange] = useState([startOfMonth(new Date()), new Date()]);
  useEffect(()=>{
    if(range[0]!=null && range[1]!=null){
      setOpciones((prevState)=>{
   return {
       ...prevState,
       ['fecha_ini']:formatDate(range[0]),
       ['fecha_fin']:formatDate(range[1])
   }
  
})
    }
    
 
  },[range])
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    setSearchTerm("")
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const import_info = () => {

    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setImportModalOpen(true);
   
  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    buscar_cis();
  }, []);


  const buscar_cis = () => {
    setLoadingList(true)
    
    const fetchDataPost = async () => {
      try {
        let baseURL=''
        baseURL = server.url+'/api/v1/cassia/events_vs_tickets/events_closed/';
        const start_date  = '?fecha_inicio='+opciones.fecha_ini
        const end_date = '&fecha_fin='+opciones.fecha_fin
        // const user_email = (opciones.user_email=="")?'':'&user_email='+opciones.user_email
        // const module_id = (opciones.module_id=="")?'':'&module_id='+opciones.module_id

        const url=baseURL+start_date+end_date
        // console.log(url)  
        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setLoadingList(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };


  const Exportar=(file_type)=>{
    
    let method='POST'
const body={
  "file_type": file_type,
  "audit_ids": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/audit/export', {
         method: method,  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Tech.json';
     } else if (file_type === 'csv') {
       link.download = 'Tech.csv';
     } else if (file_type === 'excel') {
       link.download = 'Tech.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

       } else {
         setExportLoading(false);
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           
        }
      };
  
      fetchDataPost();
      
}

  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  const handleChange=(e)=>{
    const {name,value}=e.target
    setOpciones((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const changeOption=(option,index)=>{
    setOpciones((prevState)=>{
        return {
            ...prevState,
            ['module_id']:option.value===0?null:(parseInt(option.value))
        }
        
    })
    // setManttoRelation(option.value)
  }
  const [importLoading, setImportLoading] = useState(false);
  const {user_email, module_id} = opciones;
  return (
   <div className="contBI">
     {/* <iframe title="Menu informes" className="framebox" 
            width="1140" 
            height="541.25" 
            src="https://app.powerbi.com/reportEmbed?reportId=5201e5c4-600a-40d8-8a4b-9882c4ff0ca4&autoAuth=true&ctid=18aed16f-dfee-4c56-9598-d2ff5a7a939f" 
            frameborder="0" 
            allowFullScreen="true">
    </iframe> */}
    <iframe title="Monitoreo Eventos" style={{width:'100%',height:'100%'}} src="https://app.powerbi.com/reportEmbed?reportId=5201e5c4-600a-40d8-8a4b-9882c4ff0ca4&autoAuth=true&ctid=18aed16f-dfee-4c56-9598-d2ff5a7a939f" frameborder="0" allowFullScreen="true"></iframe>
   </div>
      
  );
};

export default PanelBI;
